import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NotificationPage = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                });
                if (!response.ok) return;
                const data = await response.json();
                setNotifications(data.notifications || []);
            } catch (error) {
                console.error("Failed to fetch notifications", error);
            } finally {
                setLoading(false);
            }
        };
        fetchNotifications();
    }, [token]);

    const handleClick = async (notif) => {
        // Mark as read before navigating
        if (!notif.is_read) {
            try {
                await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/${notif.id}/mark-read/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                });
                setNotifications((prev) =>
                    prev.map((n) => n.id === notif.id ? { ...n, is_read: true } : n)
                );
            } catch (err) {
                console.error("Failed to mark as read", err);
            }
        }
        navigate(`/notifications/${notif.id}`, { state: { notif } });
    };

    return (
        <div style={{ padding: "30px", maxWidth: "700px", margin: "0 auto" }}>

            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px" }}>
                
                {/* ✅ UPDATED LEFT SIDE */}
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    
                    {/* 🔙 Back Button */}
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            background: "#f3f4f6",
                            border: "none",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            cursor: "pointer",
                            fontSize: "13px",
                            color: "#374151",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px"
                        }}
                    >
                        <i className="fa-solid fa-arrow-left"></i>
                        Back
                    </button>

                    {/* 🏠 Dashboard Button */}
                    <button
                        onClick={() => navigate("/dashboard")}
                        style={{
                            background: "#10b981",
                            border: "none",
                            borderRadius: "6px",
                            padding: "6px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px"
                        }}
                    >
                        <i className="fa-solid fa-house"></i>
                        Dashboard
                    </button>

                    <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "700" }}>
                        All Notifications
                    </h2>
                </div>

                <span style={{
                    fontSize: "13px",
                    background: "#fef2f2",
                    color: "#dc2626",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    fontWeight: "600",
                }}>
                    {notifications.filter(n => !n.is_read).length} Unread
                </span>
            </div>

            {/* Loading */}
            {loading ? (
                <div style={{ textAlign: "center", padding: "40px", color: "#9ca3af" }}>
                    <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "24px" }}></i>
                </div>
            ) : notifications.length === 0 ? (
                <div style={{ textAlign: "center", color: "#9ca3af", padding: "40px" }}>
                    <i className="fa-solid fa-bell-slash" style={{ fontSize: "40px", marginBottom: "12px", display: "block" }}></i>
                    No notifications found
                </div>
            ) : (
                notifications.map((notif) => (
                    <div
                        key={notif.id}
                        onClick={() => handleClick(notif)}
                        style={{
                            background: notif.is_read ? "#f9fafb" : "#ffffff",
                            border: `1px solid ${notif.is_read ? "#e5e7eb" : "#d1fae5"}`,
                            borderLeft: `4px solid ${notif.is_read ? "#d1d5db" : "#10b981"}`,
                            borderRadius: "10px",
                            padding: "16px",
                            marginBottom: "12px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            opacity: notif.is_read ? 0.65 : 1,
                            cursor: "pointer",
                            transition: "all 0.2s",
                            boxShadow: notif.is_read ? "none" : "0 2px 8px rgba(16,185,129,0.08)",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-1px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                    >
                        <div style={{ display: "flex", gap: "12px", flex: 1 }}>
                            {/* Avatar */}
                            <div style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                background: notif.is_read
                                    ? "linear-gradient(135deg, #9ca3af, #d1d5db)"
                                    : "linear-gradient(135deg, #10b981, #14b8a6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontWeight: "700",
                                fontSize: "15px",
                                flexShrink: 0,
                            }}>
                                {notif.employee?.first_name?.charAt(0)?.toUpperCase() || "N"}
                            </div>

                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: notif.is_read ? "#9ca3af" : "#111",
                                    marginBottom: "4px",
                                }}>
                                    {notif.title}
                                </div>
                                <div style={{
                                    fontSize: "13px",
                                    color: notif.is_read ? "#9ca3af" : "#6b7280",
                                    marginBottom: "6px",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    maxWidth: "380px",
                                }}>
                                    {notif.description}
                                </div>
                                <div style={{ fontSize: "11px", color: "#9ca3af" }}>
                                    {notif.employee?.first_name} {notif.employee?.last_name} · {notif.created_at}
                                </div>
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px", flexShrink: 0 }}>
                            <span style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                color: notif.is_read ? "#16a34a" : "#dc2626",
                                background: notif.is_read ? "#f0fdf4" : "#fef2f2",
                                padding: "2px 8px",
                                borderRadius: "20px",
                                whiteSpace: "nowrap",
                            }}>
                                {notif.is_read ? "Read" : "Unread"}
                            </span>
                            <i className="fa-solid fa-chevron-right" style={{ fontSize: "12px", color: "#9ca3af" }}></i>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default NotificationPage;